import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footerContainer}>
      <div className={styles.copyright}>Made with ♜️ © 2026 Rook Tech LLC</div>
    </footer>
  );
}

export default Footer;
